// Kompakt yatay bar chart — CRM chart lib'i olmadigi icin minimal MUI + Box.
// Renk paletini theme.palette'ten uretir; ayrica caller color map paslayabilir.

import { Box, Typography, useTheme, alpha } from '@mui/material';

const DistributionBarChart = ({ data = {}, labelMap = {}, colorMap = {}, emptyText = 'Veri yok' }) => {
  const theme = useTheme();

  // Fallback palette — theme'in semantic renkleri, sabit hex yok.
  const defaultColors = [
    theme.palette.primary.main,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.error.main,
    theme.palette.secondary.main,
  ];

  const entries = Object.entries(data)
    .filter(([, count]) => count > 0)
    .sort(([, a], [, b]) => b - a);

  if (entries.length === 0) {
    return (
      <Typography variant="caption" color="text.disabled"
        sx={{ display: 'block', textAlign: 'center', py: 1.5, fontStyle: 'italic' }}>
        {emptyText}
      </Typography>
    );
  }

  const total = entries.reduce((s, [, v]) => s + v, 0);
  const max = entries[0][1];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.85 }}>
      {entries.map(([key, count], idx) => {
        const width = Math.max(4, (count / max) * 100);
        const pct = ((count / total) * 100).toFixed(0);
        const color = colorMap[key] || defaultColors[idx % defaultColors.length];
        const label = labelMap[key] || key;
        return (
          <Box key={key}>
            <Box sx={{
              display: 'flex', alignItems: 'baseline',
              justifyContent: 'space-between', mb: 0.35,
            }}>
              <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
                {label}
              </Typography>
              <Typography sx={{ fontSize: 11, color: 'text.disabled', fontVariantNumeric: 'tabular-nums' }}>
                <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>{count}</Box>
                {' · '}%{pct}
              </Typography>
            </Box>
            <Box sx={{
              height: 6, borderRadius: 3,
              bgcolor: alpha(theme.palette.text.primary, 0.06),
              overflow: 'hidden', position: 'relative',
            }}>
              <Box sx={{
                width: `${width}%`, height: '100%', borderRadius: 3,
                background: `linear-gradient(90deg, ${color} 0%, ${alpha(color, 0.85)} 100%)`,
                transition: 'width 400ms cubic-bezier(0.4,0,0.2,1)',
              }} />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default DistributionBarChart;
